import { h, JSX } from 'preact'
import { LocalizedName } from '../../../../domain'
import { Message } from '../../../../../lib/intl/Message'
import styles from './VissteDuAt.module.css'
import { Diagonal } from '../../../shared/Decoration'

interface Props extends JSX.HTMLAttributes {
  totalt: number
  navn: LocalizedName
  frammoteProsent: number
  ferdigOpptalt: boolean
  modifiers?: any
}

export function Stemmeprosent({ totalt, navn, frammoteProsent, ferdigOpptalt, modifiers }: Props) {
  return (
    <div>
      <Message
        class={styles.intro}
        id="visste-du-at-stemmeprosent-intro"
        values={{ navn, innbyggere: totalt }}
        modifiers={{ ...modifiers, 'under-opptelling': !ferdigOpptalt }}
      />
      <div class={styles.mainWrapper}>
        <Diagonal class={styles.decoration} />
        <div class={styles.main}>
          <Message
            class={styles.value}
            id="visste-du-at-stemmeprosent-verdi"
            values={{ verdi: frammoteProsent }}
          />
          <Message class={styles.description} id="visste-du-at-stemmeprosent-verdi-beskrivelse" />
        </div>
      </div>
      <div class={styles.summary}>
        <Message id="visste-du-at-stemmeprosent-oppsummering" values={{ differanse: 1 }}>
          &nbsp;
        </Message>
      </div>
    </div>
  )
}
